export const heroOne = {
	reverse: true,
	inverse: true,
	topLine: {
		text: 'Founded in ...',
	},
	headline: "We have been in business for 900 years",
	description: 'We have designed and implemented the best cloud security solutions',
	buttonLabel: 'Find More',
	imgStart: 'start',
	img: './assets/svg/Deal.svg',
	start: 'true',
};

export const heroTwo = {
	reverse: false,
	inverse: false,
	topLine: {
		text: 'Designed & Developed',
	},
	headline: 'The bestest practices',
	description: "Our clients have had the best experience working with us, and don't forget who try nothing have nothing",
	buttonLabel: 'View Project',

	linkTo: '/more',
	imgStart: 'start',
	img: './assets/svg/Connection.svg',
	start: 'true',
};

export const heroThree = {
	reverse: true,
	inverse: true,
	topLine: {
		text: 'Highly reputed brand',
	},
	headline: 'Why us? ',
	description:
		'Our 900 year, experience have allowed us to use the most great innovative technologies and methodologies',
	buttonLabel: 'View Project',

	linkTo: '/download',
	imgStart: '',
	img: './assets/svg/ChartUp.svg',
	start: 'true',
};
